export enum LoginStage {
  Initialization = 'Initialization',
  Identity = 'Identity',
  PasswordChallenge = 'PasswordChallenge',
  SSOChallenge = 'SSOChallenge',
  SSOSuccess = 'SSOSuccess',
  PasscodeSuccess = 'PasscodeSuccess',
  CreatePasscode = 'CreatePasscode',
  VerifyPasscode = 'VerifyPasscode',
  CreatePasscodeSuccess = 'CreatePasscodeSuccess',
  PasscodeChallenge = 'PasscodeChallenge',
  PasswordSuccess = 'PasswordSuccess',
}
